module.exports = __webpack_public_path__ + "img/668.46e9846f.jpg";